import { render, staticRenderFns } from "./AddToCalendar.vue?vue&type=template&id=40520998&"
import script from "./AddToCalendar.vue?vue&type=script&lang=ts&"
export * from "./AddToCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./AddToCalendar.vue?vue&type=style&index=0&id=40520998&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports